import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { AdminColors } from '../../../Admin/constants/adminColors';
import FontFamily from '../../../../constants/fonts';

interface ConfigSummaryBoxProps {
  label: string;
  value: string;
  note?: string;
}

/** .people-config-summary: highlighted box, for example "Takes effect: Start of the next fiscal week...". */
const ConfigSummaryBox: React.FC<ConfigSummaryBoxProps> = ({ label, value, note }) => (
  <View style={styles.box}>
    <Text style={styles.label}>{label}</Text>
    <Text style={styles.value}>{value}</Text>
    {note ? <Text style={styles.note}>{note}</Text> : null}
  </View>
);

const styles = StyleSheet.create({
  box: {
    backgroundColor: AdminColors.blue25,
    borderLeftWidth: 4,
    borderLeftColor: AdminColors.blue700,
    borderRadius: 6,
    paddingHorizontal: 16,
    paddingVertical: 12,
    minHeight: 78,
  },
  label: {
    fontSize: 12,
    lineHeight: 18,
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.bold,
    textTransform: 'uppercase',
    letterSpacing: 0.35,
  },
  value: {
    fontSize: 14,
    lineHeight: 20,
    color: AdminColors.blue900,
    fontFamily: FontFamily.bold,
    marginTop: 4,
  },
  note: {
    fontSize: 12,
    lineHeight: 18,
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.regular,
    marginTop: 3,
  },
});

export default ConfigSummaryBox;
